import React from 'react';
import { ShowGrid } from '../../../components';

import ShowActions from './ShowActions';
import LeaveDetails from './LeaveDetails';
import AccountList from './AccountList';

const LeaveShow = (props) => {
  return (
    <ShowGrid
      {...props}
      actions={<ShowActions />}
      titleSource={['cleaner_fullname', 'cleaner_id']}
    >
      <LeaveDetails />
      <AccountList />
    </ShowGrid>
  );
};

export default LeaveShow;
